module.exports = __webpack_public_path__ + "img/rainbow.76bc2369.svg";